import React from "react";
import { Grid } from "@mui/material";
import FormField from "layouts/pages/account/components/FormField";
import SettingsCard from "./SettingsCard";

const SocialLinksSection = ({ inputData, autoSaveField }) => {
  const save = (e) => {
    if (autoSaveField) autoSaveField(e.target.name, e.target.value);
  };
  return (
    <SettingsCard
      title="Social & External Links"
      subtitle="Add your social media and contact links"
    >
      <Grid container spacing={2.5}>
        <Grid item xs={12} md={6}>
          <FormField
            label="Facebook"
            placeholder="Facebook"
            name="facebook"
            defaultValue={inputData?.facebook}
            onBlur={save}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormField
            label="Instagram"
            placeholder="Instagram"
            name="instagram"
            defaultValue={inputData?.instagram}
            onBlur={save}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormField
            label="LinkedIn"
            placeholder="LinkedIn"
            name="linkedin"
            defaultValue={inputData?.linkedin}
            onBlur={save}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormField
            label="Twitter"
            placeholder="Twitter"
            name="twitter"
            defaultValue={inputData?.twitter}
            onBlur={save}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormField
            label="Youtube"
            placeholder="Youtube"
            name="youtube"
            defaultValue={inputData?.youtube}
            onBlur={save}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormField
            label="Contact Us"
            placeholder="Contact Us"
            name="contact_us"
            defaultValue={inputData?.contact_us}
            onBlur={save}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormField
            label="Learn More"
            placeholder="Learn More"
            name="learn_more"
            defaultValue={inputData?.learn_more}
            onBlur={save}
          />
        </Grid>
      </Grid>
    </SettingsCard>
  );
};

export default SocialLinksSection;
